import { useQuery } from "@apollo/client";
import * as React from "react";
import { CountriesData } from "../../components/CountryPicker/types";
import LoadingComponent from "../../components/Loaders/storeContextLoader";
import {
  CitiesDataProp,
  RegionsDataProp,
} from "../../pages/Branches/create/types";
import { AssetProps } from "../../pages/SingleAssets/Store-Specific/types";
import { GET_CURRENT_STORE_DETAILS } from "../graphql/Auth";

interface ICurrentStoreDetailsInput {}
interface ICurrentStoreDetailsOutput {
  storeMe: {
    _id: string;
    code: string;
    name: string;
    slug: string;
    logo: AssetProps;
    banner: AssetProps;
    tagline: string;
    description: string;
    email: string;
    phone: string;
    address: string;
    countries: CountriesData[];
    regions: RegionsDataProp[];
    cities: CitiesDataProp[];
    package: {
      _id: string;
      code: string;
      name: string;
      description: string;
      features: string[];
      price: number;
      priority: string;
      createdAt: Date;
    };
    status: boolean;
    createdAt: Date;
  };
}

const CurrentStoreDetails = React.createContext(
  {} as ICurrentStoreDetailsOutput
);
export const useCurrentStore = () => React.useContext(CurrentStoreDetails);

const StoreContextComponent: React.FC = ({ children }) => {
  const { data, loading } = useQuery<
    ICurrentStoreDetailsOutput,
    ICurrentStoreDetailsInput
  >(GET_CURRENT_STORE_DETAILS);
  return (
    <React.Fragment>
      {loading ? (
        <React.Fragment>
          <LoadingComponent />
        </React.Fragment>
      ) : (
        <React.Fragment>
          <CurrentStoreDetails.Provider
            value={data as ICurrentStoreDetailsOutput}
          >
            {children}
          </CurrentStoreDetails.Provider>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default StoreContextComponent;
